import invariant from "tiny-invariant";
import { isMatching, P } from "ts-pattern";

import { fetchWithAuth } from "~/common/fetch";
import { remoteLog, shouldLogError } from "~/common/logging";
import { API_TOKEN } from "~/config";
import type { AppDispatch } from "~/store";

const tokenPattern = {
  token: P.string,
};

export function getTokenAction(fields: P.infer<typeof tokenPattern>) {
  return { type: "GET_TOKEN_SUCCESS", fields } as const;
}

export function getToken() {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchWithAuth(API_TOKEN);
      if (!response.ok) {
        throw new Error("Error occurred trying to fetch token");
      }
      const fields = await response.json();
      invariant(isMatching(tokenPattern, fields), `${API_TOKEN} - unexpected json received`);
      dispatch(getTokenAction(fields));
    } catch (err) {
      if (shouldLogError(err)) {
        remoteLog(err, "getToken");
      }
    }
  };
}
